"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("imageUtils", function ($q) {
  return {
    /**
     * Get image dimension for given url.
     * This is achieved by waiting for the image to load and check the width and height attributes.
     * This is a asynchronous method
     *
     * @param imageUrl The url of the image to get dimensions for.
     * @returns {deferred.promise|*} promise resolving with the image dimensions
     */
    getDimensions: function getDimensions(imageUrl) {
      var deferred = $q.defer();
      var img = new Image();
      img.onload = function () {
        deferred.resolve({
          width: img.width,
          height: img.height
        });
      };
      img.onerror = function () {
        deferred.reject();
      };
      img.src = imageUrl;
      return deferred.promise;
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/utils/imageUtils.js
// module id = 2756
// module chunks = 13